export default __webpack_public_path__ + "static/media/circle-checkin.3e5f5ac0.svg";